<template>
  <div>
    <b-card v-if="account != null && !isAccountEmpty" class="surrounding-card" :style="'background: linear-gradient(to right top, #5f135f 35%, ' + productColor() + ' 52%)'">
      <b-card no-body class="mb-1" style="border-radius: 16px 16px 16px 16px">


        <b-card-body class="outer-account-field">
          <div v-if="this.subscription != null || this.activeproduct != null || this.account.flexiplan != null">
            <fieldset class="account-field">
              <legend>
                Welcome to your account{{account.commonName!=null&&account.surname!=null?', ' + account.commonName + ' ' + account.surname:''}}
              </legend>
            <p>Created : {{ $options.filters.dateFormat(new Date(this.account.created), "dddd, MMM D YYYY")}}</p>
            <p>Username : {{account.username}}</p>
            <!-- {{account}} -->
            <p v-if="account.clientnote != null">Note : {{ this.account.autonote}}</p>
            <p v-if="account.autonote != null">Client note : {{ this.account.clientnote}}</p>
            <p>Email : <span v-if="this.account.email !== null" >{{ this.account.email}}&nbsp;
                <span v-if="this.account.verfied">(Verified)</span>
                <span v-if="! this.account.verfied">(Unverified)</span>
              </span>
              <span v-else>None registered</span>
            </p>
            <p>
              Mobile : <span v-if="account.mobile != null">{{ account.mobile}}</span>
              <span v-else>None registered</span>  
            </p>
            <p>
              Site : <span v-if="account.site != null" >{{ account.site.name}} <br /></span>
            </p>

              <b-card class="product-card" body-class="subcard-body-class" :style="'border-color: ' + productColor()">
                <div><b>Current Bandwidth Plan</b></div>
                <div>
                  <span v-if="activeproduct == null">This account does not have a current plan.<br /></span>
                  <div v-else>
                    <span>Product : <strong :style="'color: ' + productColor()">{{activeproduct.name}}</strong><br /></span>
                    <span>Upload / Download : {{activeproduct.upDescription}} / {{activeproduct.downDescription}}<br /></span>
                    <span v-if="activeuntil != null"><br />Device Limit : {{ products.find(p => p.productid == activeproduct.productid).devices }}<highlight-button v-if="totalDevices > products.find(p => p.productid == activeproduct.productid).devices && activeproduct.productid < products.find(p => p.productid === Math.max(...products.map(p => p.productid))).productid"></highlight-button><br /></span>
                    <span v-if="activeuntil != null">Registered Devices : <b :style="'color: ' + (totalDevices > products.find(p => p.productid == activeproduct.productid).devices ? 'red' : 'green')">{{totalDevices}}</b><br /><br /></span>
                    
                    <span v-if="activeuntil != null">Expires : {{$options.filters.dateFormat(new Date(activeuntil), 'dddd, MMM D YYYY')}}<br /></span>
                  </div>
                </div>
                
              </b-card>
              <b-card v-if="this.account.flexiplan != null" body-class="subcard-body-class" class="product-card" :style="'border-color: ' + productColor()">
                <div><b>FlexiPlan</b> <b v-if="activeproduct" class="active-label">ACTIVE</b><b class="inactive-label" v-else>INACTIVE</b></div>
                <div v-if="account.flexiplan.product != null">
                  Product: <strong :style="'color: ' + productColor()">{{ products.find(p => p.productid == account.flexiplan.product.productid).name }}</strong><br />
                  Current Balance: <strong>{{ account.flexiplan.credits }}</strong> {{ account.flexiplan.credits <= 1 ? 'FlexiCredit' : 'FlexiCredits' }}<br />
                  Daily Cost: <strong>{{ account.flexiplan.product.credits }}</strong> {{ account.flexiplan.product.credits <= 1 ? 'FlexiCredit' : 'FlexiCredits' }}<br /><br />
                  <strong v-if="activeproduct != null && account.flexiplan.product.productid != activeproduct.productid">Your bandwidth will change to {{ products.find(p => p.productid == account.flexiplan.product.productid).upDescription }}.<br />
                  Your limit will become {{ products.find(p => p.productid == account.flexiplan.product.productid).devices }} devices from your next renewal.</strong><br />
                  Upgrade to a subscription or purchase more credits via <router-link to="/buysubscribe">Subscribe/Buy</router-link>.
                  <span v-if="account != null && account.flexiplan != null && activeproduct == null && account.flexiplan.credits != 0">
                    <br /><br />Click <b-button class="p-0 mt-n1" variant="link" @click="startDayAccess">here</b-button> to gain access 
                    <strong v-if="account != null && account.flexiplan != null && account.flexiplan.credits >= account.flexiplan.product.credits">(action has a cost of {{ account.flexiplan.product.credits }}{{ account.flexiplan.product.credits === 1 ? ' FlexiCredit' : ' FlexiCredits' }})</strong>
                    <strong v-if="account != null && account.flexiplan != null && (account.flexiplan.product.credits > account.flexiplan.credits)">(as you have {{ account.flexiplan.product.credits - account.flexiplan.credits }} less than the {{ account.flexiplan.product.credits }}{{ account.flexiplan.product.credits === 1 ? ' FlexiCredit' : ' FlexiCredits' }} required for your tier, this will redeem access today on the {{ this.products.find((product) => product.credits === account.flexiplan.credits).name }} product)</strong>.
                    <br />
                  </span>
                </div>
                <div v-else>
                  FlexiPlan Error: Please contact SoldierNET.
                </div>
              </b-card>
              <b-card v-if="subscription != null || this.account.flexiplan == null" body-class="subcard-body-class" class="product-card" :style="'border-color: ' + productColor()">
                <div><b>Subscription</b> <b v-if="subscription && activeproduct" class="active-label">ACTIVE</b><b class="inactive-label" v-else>INACTIVE</b></div>
                <div v-if="subscription != null">
                  You have an <b>{{currentProduct.name}}</b> subscription which will 
                  take payment once every month until you cancel it.
                  <span v-if="subscription.provider != 'PAYPAL'"><br />You will be charged £{{currentPrice}} when your subscription renews on {{$options.filters.dateFormat(new Date(subscription.nextPaymentDate), "dddd")}}, {{$options.filters.dateFormat(new Date(subscription.nextPaymentDate), "MMM D YYYY")}}.</span>
                  <br v-if="activeproduct != null && subscription.product.productid != activeproduct.productid && subscription.provider != 'PAYPAL'" />
                  <strong v-if="activeproduct != null && subscription.product.productid != activeproduct.productid"><br />Your bandwidth will change to {{ products.find(p => p.productid == subscription.product.productid).upDescription }}.<br />
                  Your limit will become {{ products.find(p => p.productid == subscription.product.productid).devices }} devices from your next renewal.</strong><br />
                </div>
                <div v-else>
                  You do not have an active subscription plan.
                  <br />
                  Purchase a subscription via <router-link to="/buysubscribe">Subscribe/Buy</router-link>.
                </div>
                <b-card class="product-card mt-2 mb-n1" style="border: solid 3px red" v-if="subscription != null && subscription.provider == 'PAYPAL'">
                  <div style="color: red;"><b>Account Alert</b></div>
                  <span class="mt-2" style="display: inline-block;">We have recently moved to a new system with a new payment provider which will provide users with access to new service Plans.</span>
                  <br />
                  Migrating your account will require a new subscription (cost adjusted for existing credit).
                  <br />
                  You will not lose any of your existing access time.
                  <br />
                  It is necessary to re-subscribe to a new Plan after you unsubscribe.
                  <br />
                  Your access will expire if you do not re-subscribe.
                  <br />
                  <b-button @click="unsubscribePaypalAndNav" class="my-2 mr-2">Click here</b-button>  to unsubscribe and be redirected to the Subscribe/Buy page.
                  <br />
                  More info on changes available at <a href="https://www.soldiernet.co.uk/updates/" target="_blank">https://www.soldiernet.co.uk/updates/</a>
                </b-card>
                <b-card class="product-card mt-3 mb-n2" style="border: solid 3px red" v-if="subscription != null && activeproduct == null">
                  <div style="color: red;"><b>Subscription Issue</b></div>
                  <span class="mt-2" style="display: inline-block;">You currently have a subscription that has failed to renew.</span>
                  <br />
                  This could mean a payment has failed, which is most commonly caused by recieving a new bank card.
                  <br />
                  In order to gain access, you must remove your failed subscription via the <router-link to="/adjustplan">Adjust Current Plan</router-link> page and resubscribe.
                </b-card>
              </b-card>
            </fieldset>
          </div>



          <div v-else>
            <fieldset class="account-field">
              <legend>
                Welcome to your account {{account.commonName!=null&&account.surname!=null?', ' + account.commonName + ' ' + account.surname:''}}
              </legend>
            <p>Created : {{ $options.filters.dateFormat(new Date(this.account.created), "dddd, MMM D YYYY")}}</p>
            <p>Username : {{account.username}}</p>
            <p v-if="account.clientnote != null">Note : {{ this.account.autonote}}</p>
            <p v-if="account.autonote != null">Client note : {{ this.account.clientnote}}</p>
            <p>Email : <span v-if="this.account.email !== null" >{{ this.account.email}}&nbsp;
                <span v-if="this.account.verfied">(Verified)</span>
                <span v-if="! this.account.verfied">(Unverified)</span>
              </span>
              <span v-else>None registered</span>
            </p>
            <p>
              Mobile : <span v-if="account.mobile != null">{{ account.mobile}}</span>
              <span v-else>None registered</span>  
            </p>
            <p>
              Site : <span v-if="account.site != null" >{{ account.site.name}} <br /></span>
            </p>

              <b-card class="product-card" body-class="subcard-body-class" :style="'border-color: ' + productColor(null)">
                <div><b>Current Bandwidth Plan</b></div>
                  <div>
                    <span>This account does not have a current plan.<br /></span>
                  </div>
                
              </b-card>
              <b-card class="product-card" body-class="subcard-body-class" :style="'border-color: ' + productColor(null)">
                <div><b>Subscription</b></div>
                <div>
                  You do not have a future plan.
                  <br />
                  Purchase a subscription via <router-link to="/buysubscribe">Subscribe/Buy</router-link>.
                </div>
              </b-card>
            </fieldset>

          </div>
        </b-card-body>
      </b-card>
    </b-card>
    <b-card v-else>
      <b-card-body>
        <h3>Error loading page.</h3>
      </b-card-body>
    </b-card>
    <b-modal v-if="subscription != null && subscription.provider == 'PAYPAL'" v-model="paypalPopup" modal-class="warning-modal-paypal" title="Account Alert" header-text-variant="danger" hide-backdrop hide-footer centered ok-only size="md">
      <span class="mt-2" style="display: inline-block;">We have recently moved to a new system with a new payment provider which will provide users with access to new service Plans.</span>
      <br />
      Migrating your account will require a new subscription (cost adjusted for existing credit).
      <br />
      You will not lose any of your existing access time.
      <br />
      It is necessary to re-subscribe to a new Plan after you unsubscribe.
      <br />
      Your access will expire if you do not re-subscribe.
      <br />
      <b-button @click="unsubscribePaypalAndNav" class="my-2 mr-2">Click here</b-button>  to unsubscribe and be redirected to the Subscribe/Buy page.
      <br />
      More info on changes available at <a href="https://www.soldiernet.co.uk/updates/" target="_blank">https://www.soldiernet.co.uk/updates/</a>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions , mapState } from 'vuex'
import { checkMyStatus } from '../../cpd'
import HighlightButton from '../general/HighlightButton.vue'

export default {
  components: { HighlightButton },
    name: "AccountInfo",
    data: {
      totalDevices: 0,
      paypalPopup: true
    },
    computed: {
      ...mapState("captive", {      
        onnet: state => state.onnet
      }),
      ...mapGetters({
        products: "pricing/getProducts",
        prices: "pricing/getPrices",
        subscription: "plan/getSubscription",
        activeproduct: "plan/getActiveProduct",
        activeuntil: "plan/getActiveUntil",
        account: "account/account"
      }),
      isAccountEmpty() {
        return this.account && Object.keys(this.account).length === 0;
      },
      currentProduct() {
        return this.subscription != null && this.products != null ? this.products.find((product) => product?.productid === this.subscription.product.productid) : null
      },
      currentPrice() {
        return this.subscription != null && this.prices != null ? this.prices.find(p => p.productid === this.subscription.product.productid).monthlyPrice.toFixed(2) : null
      },
    },
    methods: {
      ...mapActions({
        getSite: 'account/getSite'
      }),
      unsubscribePaypalAndNav() {
        this.$log.onError('starting paypal unsub')
        this.$portalapi.get('/legacy/unsubscribe', { params: {userName: this.account.username} } ).then( (response) => {
          this.$log.onError(JSON.stringify(response));
          this.paypalPopup = false;
          this.$router.push('/buysubscribe');
        })
      },
      productColor() {
        if (this.subscription != null) {
          switch (this.subscription.product.productid) {
            case 1: return '#38AADE'
            case 2: return '#EE811A'
            case 3: return '#5DB12F'
            default: return '#471747'
          }
        } else if (this.account.flexiplan != null) {
          switch (this.account.flexiplan.product.productid) {
            case 1: return '#38AADE'
            case 2: return '#EE811A'
            case 3: return '#5DB12F'
            default: return '#471747'
          }
        } else if (this.activeproduct != null) {
          switch (this.activeproduct.productid) {
            case 1: return '#38AADE'
            case 2: return '#EE811A'
            case 3: return '#5DB12F'
            default: return '#471747'
          }
        }
        else return '#471747'
      },
      startDayAccess() {
        let credits = this.account.flexiplan.credits >= this.account.flexiplan.product.credits ? this.account.flexiplan.product.credits : this.account.flexiplan.credits
        let productid = this.products.find((product) => product.credits === credits).productid
        this.$portalapi.get('flexiplan/day', { params: { productid: productid, credits: credits } } )
        .then((response) => {
          store.dispatch("plan/initialiseSubscription");
          store.dispatch("event/initialiseEventtype");
          window.location.reload();
        }).catch((error) => {
          this.$log.onError(error.data);
          alert('Failed to start FlexiPlan access. Please buy credits if you have less than the required amount or contact SoldierNET.');
        })
      }
    },
    beforeMount: function() {


      store.dispatch('pricing/initialiseProducts');
      store.dispatch('pricing/initialiseWorldpay');
      store.dispatch('pricing/initialiseUiSettings');


      store.dispatch('pricing/initialisePrices', true)
      store.dispatch("event/initialiseEventtype")
      store.dispatch('account/getAccount')
      store.dispatch("plan/initialiseSubscription")
      this.paypalPopup = true;

      this.getSite().then(() => {
        if ( this.onnet )
          checkMyStatus();
      });

      this.$portalapi
      .get("/myaccount/devices")
      .then((response) => {
        // device data should be sorted but lets not take a chance
        let rd = response.data    
        if ( rd )      
          console.log(rd)
          console.log(rd.length)
          this.totalDevices = rd.length;
      })
      .catch((error) => {
        this.$log.onError("error fetching devices");
      });
    }
}
</script>

<style lang="scss" scoped>

.card-header:first-child {
  border-radius: 2rem 2rem 0 0;
}

.product-card {
  border-radius: 16px 16px 16px 16px;
  margin-bottom: 0.5rem !important;
}

legend {
  font-weight: bold;
  padding: 0rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: fit-content;
}

.surrounding-card {
  border-radius: 16px 16px 16px 16px;
  box-shadow: 28px 24px 12px 6px grey;
  border: none;
}

.account-field {
  border: 1px black solid;
  padding: 0 1rem 0 1rem;
  border-radius: 14px 14px 14px 14px;
}

.outer-account-field {
  // border: 1px black solid;
  padding: 0.5rem 0.7rem 0.7rem 0.7rem;
  border-radius: 14px 14px 14px 14px;
}

.active-label {
  float: right;
  color: purple;
}

.inactive-label {
  float: right;
  color: grey;
}

.subcard-body-class {
  padding: 0.8rem !important;
}

.warning-modal-paypal {
  border-radius: 22px;
  border: 2px solid red;
}

</style>